import React from 'react';
import withIcon from '../utilities/withIcon';

const IconLogoLinkedIn = () => {
  return (
    <g>
      <path d="m14.4777.3973h-12.9587a1.11 1.11 0 0 0 -1.1215 1.0964v13.0118a1.11 1.11 0 0 0 1.1215 1.0972h12.9587a1.1124 1.1124 0 0 0 1.1248-1.0972v-13.0118a1.1116 1.1116 0 0 0 -1.1248-1.0964zm-9.57 12.9565h-2.2577v-7.2561h2.2579zm-1.1277-8.2475a1.3078 1.3078 0 1 1 1.3069-1.308 1.3072 1.3072 0 0 1 -1.3069 1.308zm9.5747 8.2476h-2.2547v-3.5287c0-.8415-.0145-1.924-1.1719-1.924-1.1735 0-1.3525.9171-1.3525 1.8638v3.5889h-2.2529v-7.2562h2.1617v.9923h.0309a2.3689 2.3689 0 0 1 2.1337-1.1721c2.2835 0 2.7054 1.5024 2.7054 3.4567z" />
    </g>
  );
};

export default withIcon(IconLogoLinkedIn);
